import Call from '../Call';
import {objToQs} from '../Utils';

const AdkBidFactor = {
    get(filters) {
        return Call(`adkBidFactor?${objToQs(filters)}`);
    },

    getAll(filters) {
        return Call(`adkBidFactor/all?${objToQs(filters)}`);
    },

    getAffid() {
        return Call(`adkBidFactor/affid`);
    },

    getSubids(filters) {
        return Call(`adkBidFactor/subid?${objToQs(filters)}`);
    },

    getSubidsAll(filters) {
        return Call(`adkBidFactor/subid/all?${objToQs(filters)}`);
    }
}

export default AdkBidFactor;


// WEBPACK FOOTER //
// ./src/services/API/components/AdkBidFactor.js